import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the datalink API
 */
export class DataLinkService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getDataLinks(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var data = await this.makeGETRequest('/api/resource/data-links' + params);		
		return data;
	}

	exportDataLinks(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/data-links/export' + params);
	}
	
	async getDataLink(dataLinkId) {
		var data = await this.makeGETRequest('/api/resource/data-links/' + dataLinkId);		
		return data;
	}	
	
	async saveDataLink(dataLink, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/data-links/' + dataLink.dataLinkId, dataLink);
		} else {
			saved = await this.makePOSTRequest('/api/resource/data-links', dataLink);
		}
		return saved;
	}	
	
	async deleteDataLink(dataLinkIds) {		
		var result = await this.makeDELETERequest('/api/resource/data-links', dataLinkIds);		
		return result;
	}
	
}	


